import { render, staticRenderFns } from "./AddCourseDescription.vue?vue&type=template&id=d3fd6d56&"
import script from "./AddCourseDescription.vue?vue&type=script&lang=ts&"
export * from "./AddCourseDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports